var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"medical-records-tab medical-records-tab--therapeutic-plan"},[_c('p',{staticClass:"text-muted mb-0"},[_vm._v(_vm._s(_vm.$t("prontuariosPage.tabs.therapeuticPlan.placeholder")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }